import { Phone } from "lucide-react";
import { useRouterState } from "@tanstack/react-router";
import { resort } from "@/data/resort";

export function MobileBookingBar() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const onReservations = pathname === "/reservations" || pathname === "/reservations/";

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-[auto_1fr] gap-2 border-t border-border bg-background/95 px-4 pt-3 backdrop-blur-md sm:hidden"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <a
        href={resort.phoneHref}
        className="eyebrow inline-flex items-center justify-center gap-2 rounded-sm border border-border px-5 py-4 text-foreground"
      >
        <Phone className="size-4" strokeWidth={1.6} /> Call
      </a>
      {onReservations ? (
        <a
          href="#availability-request"
          className="eyebrow inline-flex items-center justify-center rounded-sm bg-primary px-5 py-4 text-primary-foreground"
        >
          Start Request
        </a>
      ) : (
        <a
          href="/reservations/"
          className="eyebrow inline-flex items-center justify-center rounded-sm bg-primary px-5 py-4 text-primary-foreground"
        >
          Check Availability
        </a>
      )}
    </div>
  );
}
